import ADB from "../../../../libs/MediaSDK";
import { debug } from "@medscape/streaming-video-player/src/js/utils/debug-log";
const { Event: ADB_MEDIA_EVENTS } = ADB.Media;
const { IntersectionObserver } = window;

class InFocus {
  constructor(amp, tracker, stateObjects) {
    this.amp = amp;
    this.tracker = tracker;
    this.stateObjects = stateObjects;
    this.observer = null;

    debug.log("[MediaAnalyticsTracking][DisplayState][constructor]:", this);
  }

  destroy() {
    if (this.observer != null) {
      this.observer.disconnect();
    }
  }
  end() {
    this.destroy();
  }
  start() {
    this.destroy();
    const { amp } = this;
    let options = {
      root: null,
      rootMargin: "0px",
    };
    const handleIntersect = (entries) => {
      this.onIntersectChange(entries);
    };
    this.observer = new IntersectionObserver(handleIntersect, options);
    this.observer.observe(amp.container);
  }

  onIntersectChange(entries) {
    const { tracker, stateObjects } = this;
    const { InFocus: stateObject } = stateObjects;
    const stateName = entries[0].isIntersecting
      ? ADB_MEDIA_EVENTS.StateStart
      : ADB_MEDIA_EVENTS.StateEnd;
    debug.log(
      "[MediaAnalyticsTracking][InFocus] tracker.trackEvent \n\tstateName:",
      stateName,
      "\n\tstateObject:",
      stateObject
    );
    tracker.trackEvent(stateName, stateObject);
  }
}

export default InFocus;
